module.exports = __webpack_public_path__ + "img/cg_logo_white.5760ee79.svg";